import { render } from "./Autocomplete.vue?vue&type=template&id=1b14df99&scoped=true&ts=true"
import script from "./Autocomplete.vue?vue&type=script&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&lang=ts"

import "./Autocomplete.vue?vue&type=style&index=0&id=1b14df99&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Lucas\\Desktop\\vue3-autocomplete\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b14df99"]])